import { AdminDeletedUserListItemDto } from '@smatchy/sdk';

export type DeletedUsersByRoleFilter = 'all' | 'admin' | 'user';

export function isSelfDeletedUser(user: AdminDeletedUserListItemDto): boolean {
  if (!user.deletedBy?.id) {
    return false;
  }
  return String(user.deletedBy.id) === String(user.id);
}

export function getDeletedByDisplayName(
  user: AdminDeletedUserListItemDto,
): string {
  if (!user.deletedBy?.id) {
    return '--';
  }
  return isSelfDeletedUser(user) ? 'User' : 'Smatchy';
}

export function matchesDeletedUsersByRole(
  user: AdminDeletedUserListItemDto,
  role: DeletedUsersByRoleFilter,
): boolean {
  if (role === 'all') {
    return true;
  }
  const isSelf = isSelfDeletedUser(user);
  return role === 'user' ? isSelf : !isSelf;
}
